<mat-sidenav-container class="h-screen bg-base">
  <mat-sidenav
    #sidenav
    [mode]="sidenavMode()"
    [opened]="isDesktop()"
    class="w-64 border-r border-divider bg-foreground">
    <div class="flex items-center gap-3 px-6 h-16 border-b border-divider">
      <img
        src="assets/img/logo/logo-monogram.svg"
        alt="Romulus"
        class="w-8 h-8" />
      <span class="font-serif text-lg text-default">{{ "layout.title" | translate }}</span>
    </div>

    <nav class="flex flex-col gap-1 p-3">
      @for (item of navItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-subdued text-ruber"
          class="flex items-center gap-3 px-3 py-2 rounded-button text-secondary hover:bg-hover"
          (click)="isDesktop() || sidenav.close()">
          <mat-icon
            [svgIcon]="item.icon"
            class="icon-sm" />
          <span class="text-sm font-medium">{{ item.label | translate }}</span>
        </a>
      }
    </nav>
  </mat-sidenav>

  <mat-sidenav-content class="flex flex-col">
    <header class="flex items-center gap-2 h-16 px-4 border-b border-divider bg-foreground">
      @if (!isDesktop()) {
        <button
          mat-icon-button
          type="button"
          aria-label="Toggle navigation"
          (click)="sidenav.toggle()">
          <mat-icon svgIcon="mat:menu" />
        </button>
      }
      <div class="flex-1"></div>
      <button
        mat-icon-button
        type="button"
        aria-label="User menu"
        [matMenuTriggerFor]="userMenu">
        <mat-icon svgIcon="mat:account_circle" />
      </button>
      <mat-menu #userMenu="matMenu">
        <a
          mat-menu-item
          routerLink="/login">
          <mat-icon svgIcon="mat:logout" />
          <span>{{ "layout.logout" | translate }}</span>
        </a>
      </mat-menu>
    </header>

    <main class="flex-1 overflow-auto">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
